export interface IHeaderModuleSettings {
  isCreditorFileUploadEnabled: boolean;
}

export const defaultHederModuleSettings: IHeaderModuleSettings = {
  isCreditorFileUploadEnabled: false,
};
